import { render, staticRenderFns } from "./SupplierSuggestion.vue?vue&type=template&id=452afbb6&"
import script from "./SupplierSuggestion.vue?vue&type=script&lang=js&"
export * from "./SupplierSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports